import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagTendKeywordManagementContainer from '../../containers/tag/TagTendKeywordManagementContainer';

const TagTrendKeywordManagement = () => {
  return (
    <PageTemplate pageName={TAG_PAGE_NAME.TAG_TREND_KEYWORD_MANAGEMENT}>
      <TagTendKeywordManagementContainer />
    </PageTemplate>
  );
};

export default TagTrendKeywordManagement;
